import React, { useEffect } from 'react';
import './App.css';
import { useSession, SessionProvider } from "./context/SessionContext";
import { registerSessionHandlers } from "./api/api";
import { TimeoutWarningModal } from './components/TimeOutWarningModal';
import PageTracker from './utils/PageTracker';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import PrivateRoute from './containers/PrivateRoute/PrivateRoute';
import Navbar from './containers/Navbar/Navbar';
import {
  ThemeProvider,
} from '@mui/material/styles';
import { theme } from './theme/theme';
import Login from './pages/Login';
import OtpVerification from './pages/OTPVerification';
import { HospitalProvider } from "./context/HospitalContext";
import HospitalSelection from './containers/Auth/HospitalSelection';
import Layout from './commons/CommonLayout';
import Anatomy from './pages/Anatomy';
import Lifestyle from './pages/Lifestyle';
import Emotion from './pages/Emotion';
import PhysicalFitness from './pages/PhysicalFitness';
import History from './containers/Anatomy/History';
import Antenatal from './containers/Anatomy/Antenatal';
import Observation from './containers/Anatomy/Observation';
import Prescription from './containers/Anatomy/Treatment';
import Dashboard from './pages/DashBoard';
import { ToastProvider } from './context/ToastContext';
import SummaryPage from './pages/SummaryPage';
import RotateOverlay from './utils/RotateOverlay';
import Profile from './pages/Profile';
import { PatientProvider } from './context/ConsultationContext';
import { socket } from './socket/socket';
import { DoctorProvider } from './context/DoctorSelectionContext';
import Vitals from './containers/Anatomy/Vitals';
import VideoCall from './pages/VideoCall';
import BillingQueue from './pages/BillingQueue';
import AiCardsReview from './pages/AiCardsReview';
import AiNotificationBanner from './components/AiCards/AiNotificationBanner';
import NotificationPermissionModal from './components/AiCards/NotificationPermissionModal';
import { initFcmNotifications, syncFcmDeviceTokenIfPermitted } from './services/fcmNotificationService';

const AppContent = () => {
  const { showTimeoutModal, setShowTimeoutModal, handleLogout, setIsAuthenticated, isAuthenticated } = useSession();

  useEffect(() => {
    registerSessionHandlers(setShowTimeoutModal, setIsAuthenticated);
  }, [setShowTimeoutModal, setIsAuthenticated]);
  console.log('Base URL:develop', process.env.REACT_APP_DEVELOP);
  console.log('Base URL:prod', process.env.REACT_APP_PROD);
  console.log("nove env", process.env.NODE_ENV)
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      if (socket.connected) {
        socket.disconnect();
      }
      socket.auth = {
        token,
      };
      socket.connect();
      socket.on("connect", () => {
        console.log("socket connected",socket.id);
      });
      socket.on("connect_error", (err) => {
        console.log("socket error", err.message);
      });
    }
    return () => {
      socket.off("connect");
      socket.off("connect_error");
    };

  }, [isAuthenticated]);

  // When successfully authenticated, initialize FCM listeners and quietly sync token if already granted
  useEffect(() => {
    if (isAuthenticated) {
      initFcmNotifications();
      if (typeof window !== 'undefined' && 'Notification' in window && Notification.permission === 'granted') {
        syncFcmDeviceTokenIfPermitted();
      }
    }
  }, [isAuthenticated]);

  return (
    <Router>
      <PageTracker />
      <RotateOverlay/>
      <TimeoutWarningModal isOpen={showTimeoutModal} onLogout={handleLogout} />
      <Navbar />
      {isAuthenticated && <AiNotificationBanner />}
      {isAuthenticated && <NotificationPermissionModal />}
      <div className="App">
        <Routes>
          <Route element={<PrivateRoute />}>
            <Route path='/dashboard' element={<Dashboard />} />
            <Route path='/billing' element={<BillingQueue />} />
            <Route path='/profile' element={<Profile/>} />
            <Route path='/video-call/:appointmentId' element={<VideoCall />} />
            <Route path='/consultations/:consultationId/ai-cards' element={<AiCardsReview />} />
            <Route path='/consultation/:consultationId/ai-cards' element={<AiCardsReview />} />
            <Route path="/consultation/:consultationId/patient/:patientId" element={<Layout />}>
              <Route index element={<Navigate to="A/history" replace />} />
              <Route path='summary' element={<SummaryPage />} />
              <Route path="L" element={<Lifestyle />} />
              <Route path="E" element={<Emotion />} />
              <Route path="P" element={<PhysicalFitness />} />

              <Route path="A" element={<Anatomy />}>
                <Route index element={<Navigate to="history" replace />} />
                <Route path="history" element={<History />} />
                <Route path="antenatal" element={<Antenatal />} />
                <Route path="vitals" element={<Vitals/>} />
                <Route path="observation" element={<Observation />} />
                <Route path="treatment" element={<Prescription />} />
              </Route>
            </Route>
          </Route>
          <Route path='/' element={<Login />} />
          <Route path='/verify-otp' element={<OtpVerification />} />
          <Route path='/choose-hospital' element={<HospitalSelection />} />
        </Routes>
      </div>
    </Router>
  );
};

function App() {
  return (
    <PatientProvider>
      <ToastProvider>
        <HospitalProvider>
          <DoctorProvider>
          <ThemeProvider theme={theme}>
            <SessionProvider>
              <AppContent />
            </SessionProvider>
          </ThemeProvider>
          </DoctorProvider>
        </HospitalProvider>
      </ToastProvider>
    </PatientProvider>
  );
}

export default App
